module.exports = __webpack_public_path__ + "media/1.265d8022.mp3";